import React from "react";
import { Button, Dialog, Link } from "@sscs/ui";
import { STORE_PACKAGE_ID, STORE_PROJECT_ID } from "Constants";
import { useAppSelector, useProjectsRoute } from "Hooks";
import { useGetWhoamiQuery } from "Services";
import {
  selectDeletedPackages,
  selectDeletedProjects,
} from "Store/projects.slice";

type DeletedPackageDialogProps = {
  isOpen: boolean;
  isProjectDeleted: boolean;
  navigateTo: string;
};

const DeletedPackageDialog = ({
  isOpen,
  isProjectDeleted,
  navigateTo,
}: DeletedPackageDialogProps): React.JSX.Element => (
  <Dialog.Frame size="xs" isOpen={isOpen}>
    <Dialog.Header>
      <Dialog.Header.Title>
        {isProjectDeleted ? "Project" : "Package"} Deleted
      </Dialog.Header.Title>
    </Dialog.Header>
    <Dialog.Body>
      <Dialog.Section>
        <Dialog.Section.Content>
          <span>
            This {isProjectDeleted ? "project" : "package"} has been deleted by
            another user.
          </span>
        </Dialog.Section.Content>
      </Dialog.Section>
    </Dialog.Body>
    <Dialog.Footer>
      <Dialog.Footer.Actions>
        <Link
          to={navigateTo}
          onClick={() => {
            localStorage.removeItem(STORE_PACKAGE_ID);
            localStorage.removeItem(STORE_PROJECT_ID);
          }}
          underline="none"
        >
          <Button>Return to project{isProjectDeleted ? "s" : ""}</Button>
        </Link>
      </Dialog.Footer.Actions>
    </Dialog.Footer>
  </Dialog.Frame>
);

type DeletedPackageProps = {
  projectId: string;
  packageId: string;
};

const DeletedPackage = ({
  projectId,
  packageId,
}: DeletedPackageProps): React.JSX.Element | null => {
  const { data: whoami } = useGetWhoamiQuery();
  const projectsRoute = useProjectsRoute();
  const deletedProjects = useAppSelector(selectDeletedProjects);
  const deletedPackages = useAppSelector(selectDeletedPackages);
  const deletedProject = deletedProjects.find((item) => item.id === projectId);
  const deletedPackage = deletedPackages.find((item) => item.id === packageId);

  if (
    deletedPackage?.initiated_by === whoami?.email ||
    deletedProject?.initiated_by === whoami?.email
  ) {
    return null;
  }

  return (
    <DeletedPackageDialog
      isOpen={Boolean(deletedPackage) || Boolean(deletedProject)}
      isProjectDeleted={Boolean(deletedProject)}
      navigateTo={
        deletedPackage ? `${projectsRoute}/project/${projectId}` : projectsRoute
      }
    />
  );
};

export default DeletedPackage;
